/**
 * TextField
 * Single input field
 */

<template>
  <div class="field">
    <label v-if="label" class="label">{{ label }}</label>
    <div class="control">
      <input :value="value" @input="updateValue" class="input" type="text" :placeholder="placeholder" :disabled="disabled" />
    </div>

    <p v-show="!valid" class="help is-danger">{{ invalidMessage }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, required: true },
    label: { type: String },
    placeholder: { type: String, default: 'Enter text' },
    disabled: { type: Boolean, default: false },
    valid: { type: Boolean, default: true },
    invalidMessage: { type: String, default: 'Field is invalid' }
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value || event.srcElement.value)
    }
  }
}
</script>


<style lang="scss" scoped>

</style>

